function Navigator() {
  return (
    <div className="navigator">
      <a href="#about">About</a><br /><br />
      <a href="#experiance">Experience</a><br /><br />
      <a href="#projects">Socials+Resume</a><br /><br />
    </div>
  );
}

export default Navigator;
